/*! Auric facets — AJAX filtering, sorting, and infinite scroll for collection pages */
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-main]');
  if (!root) return;

  var grid = root.querySelector('[data-product-grid]');
  var filterForm = root.querySelector('[data-filter-form]');
  var sortSelect = root.querySelector('[data-sort-select]');

  function buildUrl(extraParams) {
    var url = new URL(root.getAttribute('data-url'), window.location.origin);
    var params = new URLSearchParams(window.location.search);
    if (extraParams) {
      extraParams.forEach(function (pair) { params.set(pair[0], pair[1]); });
    }
    url.search = params.toString();
    return url;
  }

  function fetchAndReplace(url, push) {
    root.classList.add('is-loading');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + getSectionId())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.querySelector('[data-collection-main]');
        if (newRoot) {
          root.innerHTML = newRoot.innerHTML;
          init();
          if (push) { history.pushState({}, '', url); }
          document.querySelector('[data-drawer-close]') && closeFilterDrawer();
          window.scrollTo({ top: root.offsetTop - 100, behavior: 'smooth' });
        }
      })
      .finally(function () { root.classList.remove('is-loading'); });
  }

  function getSectionId() {
    return document.body.getAttribute('data-collection-section-id') || 'main';
  }

  function closeFilterDrawer() {
    var evt = new Event('click');
    var closeBtn = document.querySelector('#FilterDrawer [data-drawer-close]');
    if (closeBtn) closeBtn.dispatchEvent(evt);
  }

  function onFilterSubmit(e) {
    e.preventDefault();
    var params = new URLSearchParams(new FormData(e.target));
    var url = buildUrl(null);
    url.search = params.toString();
    fetchAndReplace(url.toString(), true);
  }

  function onFilterChange() {
    if (filterForm) filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.dispatchEvent(new Event('submit', { cancelable: true }));
  }

  function onSortChange() {
    var url = buildUrl([['sort_by', sortSelect.value]]);
    fetchAndReplace(url.toString(), true);
  }

  function setupInfiniteScroll() {
    var sentinel = root.querySelector('[data-load-more-sentinel]');
    if (!sentinel || !sentinel.getAttribute('data-next-url')) return;
    var status = root.querySelector('[data-load-more-status]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.disconnect();
          if (status) status.hidden = false;
          fetch(sentinel.getAttribute('data-next-url') + (sentinel.getAttribute('data-next-url').indexOf('?') > -1 ? '&' : '?') + 'section_id=' + getSectionId())
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-product-grid]');
              var newSentinel = doc.querySelector('[data-load-more-sentinel]');
              if (newGrid) { grid.insertAdjacentHTML('beforeend', newGrid.innerHTML); }
              if (status) status.hidden = true;
              if (newSentinel && newSentinel.getAttribute('data-next-url')) {
                sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
                observer.observe(sentinel);
              } else {
                sentinel.remove();
              }
            });
        }
      });
    }, { rootMargin: '400px' });
    observer.observe(sentinel);
  }

  function init() {
    grid = root.querySelector('[data-product-grid]');
    filterForm = root.querySelector('[data-filter-form]');
    sortSelect = root.querySelector('[data-sort-select]');
    if (filterForm) {
      filterForm.addEventListener('submit', onFilterSubmit);
      filterForm.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', onFilterChange);
      });
    }
    if (sortSelect) sortSelect.addEventListener('change', onSortChange);
    setupInfiniteScroll();
  }

  init();

  window.addEventListener('popstate', function () {
    fetchAndReplace(window.location.href, false);
  });
})();
